import { inputClass } from "@/components/manufacturing/ManufacturingOrderIntakeShared";

/** Optional plant-packet URLs on in-app / sales-rep intake (not IdeaRoom field names). */
export function IntakePlantPacketUrlFields(props: {
  orderFormUrl: string;
  floorPlanUrl: string;
  onOrderFormUrl: (v: string) => void;
  onFloorPlanUrl: (v: string) => void;
  disabled?: boolean;
}) {
  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
      <label className="block text-xs text-gray-600 dark:text-zinc-300">
        Order form URL (optional)
        <input
          className={`${inputClass} mt-1`}
          type="url"
          value={props.orderFormUrl}
          onChange={(e) => props.onOrderFormUrl(e.target.value)}
          placeholder="https://…"
          disabled={props.disabled}
        />
      </label>
      <label className="block text-xs text-gray-600 dark:text-zinc-300">
        Floor plan URL (optional)
        <input
          className={`${inputClass} mt-1`}
          type="url"
          value={props.floorPlanUrl}
          onChange={(e) => props.onFloorPlanUrl(e.target.value)}
          placeholder="https://…"
          disabled={props.disabled}
        />
      </label>
    </div>
  );
}
